import * as z from 'zod';

export const EmbedScriptRequest = z.object({
  properties: z
    .object({
      parameters: z
        .record(z.string(), z.string())
        .describe(
          'Dynamic parameters available to the script when it runs on the site.\n\nLearn more about [using dynamic parameters](https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/embedded-script-extension-files-and-code#using-dynamic-parameters-in-your-html-code).'
        )
        .optional(),
      disabled: z
        .boolean()
        .describe('Whether to disable the script. Default: `false`.')
        .optional(),
    })
    .describe('Details of the script to embed.'),
  options: z
    .object({
      componentId: z
        .string()
        .describe(
          "Extension ID of the embedded script.\n\nYou can find the extension ID in the **Extensions** page in the [app dashboard](https://manage.wix.com/account/custom-apps). If you added the embedded script extension [using the Wix CLI](https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/add-an-embedded-script-extension), you can also find it in the extension's [`embedded.extension.ts` file](https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/embedded-script-extension-files-and-code#embeddedextensionts)."
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
    })
    .optional(),
});
export const EmbedScriptResponse = z.object({
  properties: z
    .object({
      parameters: z
        .record(z.string(), z.string())
        .describe(
          'Dynamic parameters available to the script when it runs on the site.\n\nLearn more about [using dynamic parameters](https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/embedded-script-extension-files-and-code#using-dynamic-parameters-in-your-html-code).'
        )
        .optional(),
      disabled: z
        .boolean()
        .describe('Whether to disable the script. Default: `false`.')
        .optional(),
    })
    .describe('Details of the embedded script.')
    .optional(),
});
export const GetEmbeddedScriptRequest = z.object({
  options: z
    .object({
      componentId: z
        .string()
        .describe(
          "Extension ID of the embedded script to retrieve.\n\nYou can find the extension ID in the **Extensions** page in the [app dashboard](https://manage.wix.com/account/custom-apps). If you added the embedded script extension [using the Wix CLI](https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/add-an-embedded-script-extension), you can also find it in the extension's [`embedded.extension.ts` file](https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/embedded-script-extension-files-and-code#embeddedextensionts)."
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
    })
    .optional(),
});
export const GetEmbeddedScriptResponse = z.object({
  parameters: z
    .record(z.string(), z.string())
    .describe(
      'Dynamic parameters available to the script when it runs on the site.\n\nLearn more about [using dynamic parameters](https://dev.wix.com/docs/wix-cli/guides/extensions/site-extensions/embedded-scripts/embedded-script-extension-files-and-code#using-dynamic-parameters-in-your-html-code).'
    )
    .optional(),
  disabled: z
    .boolean()
    .describe('Whether to disable the script. Default: `false`.')
    .optional(),
});
